import {API, _getAppLang, _changeAppLang, isUserLoggedIn, fetchKeysFromQueryString, getBackendUrl, _historyPush} from '@utils'
import _ from "lodash"
//************************************//
import {goTo2FAPage} from '../../utility/Utils'
//************************************//

export const _setUserToken = (json) => {
  const user = JSON.stringify(json)
  localStorage.setItem("USER_TOKEN", user)
  //Cookies.set("USER_TOKEN", token)
  if (json.user.locale !== _getAppLang()) {
    _changeAppLang(json.user.locale)
  }
}
//************************************//
export const _removeUserToken = () => {
  localStorage.removeItem("USER_TOKEN")
}
//************************************//

export const _login = ({email, password}, callback, callbackErr) => {
  API.post('/login', {email, password})
    .then(function (res) {
      callback(res)
    })
    .catch(function (res) {
      callbackErr(res)
    })
}
//************************************//
export const _loginTwoFactor = ({email, code}, callback, callbackErr) => {
  API.post('/login-2fa', {email, code})
    .then(function (res) {
      callback(res)
    })
    .catch(function ({data}) {
      callbackErr(data)
    })
}
//************************************//
export const _register = ({firstName, lastName, email}, callback, callbackErr) => {
  API.post('/register', {first_name: firstName, last_name: lastName, email})
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _forgetPassword = ({email}, callback, callbackErr) => {
  API.post('/forget-password', {email})
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _resetPassword = ({email, currentPassword, newPassword}, callback, callbackErr) => {
  API.post('/reset-password', {email, current_password:currentPassword, new_password:newPassword})
    .then(function (res) {
      callback(res)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _changePassword = (data, callback, callbackErr) => {
  API.post('/user/account/change-password', {...data})
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _resend2faCode = (data, callback, callbackErr) => {
  API.post('/resend-2fa', data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      if (callbackErr) callbackErr(data)
    })
}
//************************************//
export const _logout = (dispatch) => {
  // ** Remove user, accessToken & refreshToken from localStorage
  _removeUserToken()
  dispatch({ type: 'USER_LOGOUT' })
}

export const _postLogout = (dispatch, callback) => {
  API.post('/user/logout')
    .then(function ({data}) {
      // ** Remove user, accessToken & refreshToken from localStorage
      _removeUserToken()
      dispatch({ type: 'USER_LOGOUT' })
      if (callback) callback()
    })
}

//************************************//
export const _autoLogin = (dispatch, ability, callback) => {
  const {assertion = '',  cas_assertion = ''} =  fetchKeysFromQueryString(window.location.search, ['assertion', 'cas_assertion'])

  let endpoint = '/user/auth'
  if (assertion) {
    endpoint = `/sso/${assertion}`
  } else if (cas_assertion) {
    endpoint = `/cas/${cas_assertion}`
  }

  API.get(endpoint, {
    silent: true
  })
    .then(function (res) {
      const {data, next_step_code = ''} = res
      if (data.user) {
        _setUserToken({email: data.user.email, token: 'token', user: data.user})
        dispatch({type: "USER_LOGIN", userData: data.user, token: 'token'})
        if (data.user.abilities) {
          ability.update(data.user.abilities)
        }
        callback()
      } else {
        if (next_step_code === 'USR_2FA') {
          goTo2FAPage(data.username, data.code_sent_to, data.sent_to_method, data.expired_after, data.id)
          callback()
        } else if (next_step_code === 'AUTH_SSO_REQUIRED') {
          window.location.href = `${getBackendUrl()}/sso`
        }
      }

      //
    })
    .catch(function (res) {
      _removeUserToken()
      callback()
    })

}
//************************************//
export const _getMyProfile = (dispatch) => {
  API.get('/user/account/my-profile')
    .then(function ({data}) {
      dispatch({type: 'USER_MY_PROFILE', data})
      const userToken = JSON.parse(localStorage.getItem('USER_TOKEN'))
      userToken.user = {...userToken.user, ...data.basic_info, ...data.preference_info}
      _setUserToken(userToken)
    })
    .catch(function (res) {})
}
//************************************//
export const _changeBasicInfo = (data, callback, callbackErr) => {
  return dispatch => {
    API.post('/user/account/change-basic-info', data)
      .then(function ({data}) {
        _getMyProfile(dispatch)
      })
      .catch(function ({data}) {
        callbackErr(data.data)
      })
  }

}
//************************************//
export const _changeGeneralInfo = (data, callback, callbackErr) => {
  return dispatch => {
    API.post('/user/account/change-general-info', {...data})
      .then(function ({data}) {
        _getMyProfile(dispatch)
      })
      .catch(function ({data}) {
        callbackErr(data.data)
      })
  }

}
//************************************//
export const _changePreferences = (data, callback, callbackErr) => {
  return dispatch => {
    API.post('/user/account/change-preference-info', data)
      .then(function ({data}) {
        _getMyProfile(dispatch)
      })
      .catch(function ({data}) {
        callbackErr(data.data)
      })
  }
}
//************************************//
export const _getUserList = ({limit, page, sort, filter, withSavedQueries}, callback) => {
  API.get('/user/list', {
    params: {
      limit,
      page,
      sort,
      filter,
      with_saved_queries: withSavedQueries
    }
  })
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export const _invite = ({firstName, lastName, nickName, email}, callback, callbackErr) => {
  API.post('/user/invite', {first_name: firstName, last_name: lastName, nick_name: nickName, email})
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _resendInvite = (id) => {
  API.post(`/user/${id}/resend-invite`)
    .then(function ({data}) {
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _activeUser = (id, callback) => {
  API.put(`/user/${id}/activate-user`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _deactiveUser = (id, callback) => {
  API.put(`/user/${id}/deactivate-user`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _cancelInvitation = (id, callback) => {
  API.delete(`/user/${id}/cancel-invitation`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _editBasicInfo = ({id, firstName, lastName, nickName}, callback, callbackErr) => {
  API.post(`/user/${id}/edit-basic-info`, {first_name: firstName, last_name: lastName, nick_name: nickName})
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _getRoleList = ({limit, page, sort, filter}, callback) => {
  API.get('/user/role/list', {
    params: {
      limit,
      page,
      sort,
      filter
    }
  })
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export const _addRole = (data, callback, callbackErr) => {
  API.post('/user/role/new', data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _editRole = (data, callback, callbackErr) => {
  API.put(`/user/role/${data.id}`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export const _deleteRole = (id, callback) => {
  API.delete(`/user/role/${id}`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _setDefaultRole = (id, callback) => {
  API.put(`/user/role/${id}/set-default`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _unsetDefaultRole = (id, callback) => {
  API.put(`/user/role/${id}/unset-default`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _getRolePermissions = (id, callback) => {
  API.get(`/user/role/${id}`, {
    params: {}
  })
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export const _getPermissions = (callback) => {
  API.get(`/user/role/default-permissions`, {
    params: {}
  })
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export const _updateUserRole = ({id, roles}, callback, callbackErr) => {
  API.post(`/user/${id}/update-roles`, {roles})
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export const _searchRole = async (q = '', ids = []) => {
  const res =  await API.get('/user/role/search', {
    params: {
      limit: 20,
      q
    }
  })
  const result = _.map(res.data, (v, k) => {
    return {value: v.id, label: v.name_lang}
  })
  return result
}
//************************************//
export const _updateUserStatus = (data, callback) => {
  API.post(`/user/${data.userId}/change-status`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
    })
}
//************************************//
export function _getGroupsList({limit, page, sort, filter}, callback) {
  API.get('/user/group/list', {
    params: {
      limit,
      page,
      sort,
      filter
    }
  })
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _addGroup(data, callback, callbackErr) {
  API.post('/user/group/add', data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export function _editGroup(id, data, callback, callbackErr) {
  API.put(`/user/group/${id}`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export function _deleteGroup(id, callback) {
  API.delete(`/user/group/${id}`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _addGroupUsers(data, callback, callbackErr) {
  API.post(`/user/group/${data.groupId}/add`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function ({data}) {
      callbackErr(data?.data)
    })
}
//************************************//
export function _deleteGroupUsers(data, groupId, callback) {
  API.post(`/user/group/${groupId}/delete`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _getUsersGroupDetails(groupId, callback) {
  API.get(`user/group/${groupId}`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _getUsersGroupList({limit, page, sort, filter, groupId}, callback) {
  API.get(`user/group/${groupId}/user-group-list`, {
    params: {
      limit,
      page,
      sort,
      filter
    }
  })
  .then(function ({data}) {
    callback(data)
  })
  .catch(function (res) {})
}
//************************************//
export const _searchUser = async (q = '') => {
  const res = await API.get(`user/search`, {
    params: {
      limit: 20,
      q
    }
  })
  const result = _.map(res.data, (v, k) => {
    return {value: v.id, label: v.full_name}
  })
  return result
}
